export { PromotionBanner } from './PromotionBanner';
